import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

function initializeSliderSelectionRecipes(containerId) {
    const container = document.querySelector(containerId);

    if (container.classList.contains('slider-rtl-dynamic')) {
        if (window.innerWidth < 1024) {
            container.setAttribute('dir', 'ltr');
        } else {
            container.setAttribute('dir', 'rtl');
        }
    }

    const slider = new Swiper(containerId, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 32,
            },
        },
    });
}

$(function () {
    $('.slider-selection-recipes').each(function () {
        initializeSliderSelectionRecipes('#' + $(this).attr('id'));
    });

    $(window).on('resize', function () {
        $('.slider-rtl-dynamic').each(function () {
            if (window.innerWidth < 1024) {
                this.setAttribute('dir', 'ltr');
            } else {
                this.setAttribute('dir', 'rtl');
            }
        });
    });
});